var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Modal from 'bootstrap/js/dist/modal';
export class CookiesConsent extends Component {
    constructor() {
        super('RGPDConsent', false);
        this.settings = {};
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('#hw-cookies-consent-modal').length > 0) {
                this.mode = $('#hw-cookies-consent').data('mode');
                this.modal = new BS_Modal($('#hw-cookies-consent-modal').get(0), { backdrop: 'static', keyboard: false });
                const cookiesClosed = localStorage.getItem('hw-cookies-defined');
                if (cookiesClosed != 'true') {
                    $('#hw-cookies-consent').removeClass('d-none').addClass('d-lg-flex');
                    this.initSettings();
                }
                else {
                    this.restoreSettings();
                }
                // Show cookies modal
                $('.hw-cookies-btn-configure').on('click', (event) => {
                    event.preventDefault();
                    this.modal.show();
                });
                // Accept all
                $('.hw-cookies-btn-agree').on('click', (event) => {
                    event.preventDefault();
                    $('.hw-cookies-setting-switch').each((setting) => {
                        if (setting.data('key') === 'technical')
                            return;
                        this.settings[setting.data('key')] = setting.get(0).checked = true;
                    });
                    this.saveSettings();
                    this.restoreSettings();
                });
                // Close cookies modal
                $('.hw-cookies-btn-agree, .hw-cookies-btn-close-modal').on('click', (event) => {
                    console.log('close');
                    event.preventDefault();
                    $('#hw-cookies-consent').addClass('d-none').removeClass('d-lg-flex');
                    localStorage.setItem('hw-cookies-defined', 'true');
                    if ($('body').hasClass('page-id-29'))
                        location.href = '/books/';
                });
                // Switch update
                $('.hw-cookies-setting-switch').on('change', (event, input) => {
                    this.updateSetting(input.data('key'), input.get(0).checked);
                });
            }
            // Do not track
            if (navigator.doNotTrack) {
                $('.hw-cookies-setting-switch[data-key="traffic"]').attr('disabled', true).get(0).checked = false;
                $('.hw-do-not-track-message').removeClass('d-none');
            }
            this.success();
        });
    }
    initSettings() {
        $('.hw-cookies-setting-switch').each((setting) => {
            if (setting.data('key') === 'technical')
                return;
            this.settings[setting.data('key')] = setting.get(0).checked = this.mode == 'opt-in' ? false : true;
        });
        this.saveSettings();
        this.restoreSettings();
    }
    updateSetting(key, value) {
        this.settings[key] = value;
        this.triggerSettingChanged(key, value);
        this.saveSettings();
    }
    saveSettings() {
        localStorage.setItem('hw-cookies-settings', JSON.stringify(this.settings));
    }
    restoreSettings() {
        this.settings = JSON.parse(localStorage.getItem('hw-cookies-settings'));
        $('.hw-cookies-setting-switch').each((setting) => {
            setting.get(0).checked = this.settings[setting.data('key')];
            this.triggerSettingChanged(setting.data('key'), this.settings[setting.data('key')]);
        });
    }
    triggerSettingChanged(key, value) {
        $('body').get(0).dispatchEvent(new CustomEvent('hw-cookies-setting-' + key + '-changed', { detail: { isEnabled: value } }));
    }
}
